import { render, staticRenderFns } from "./CatalogsCheckout.vue?vue&type=template&id=f4821a88&"
import script from "./CatalogsCheckout.ts?vue&type=script&lang=ts&"
export * from "./CatalogsCheckout.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports